import React from "react";

const LoadingSpinner = ({
  message = "Loading...",
  size = "medium",
  className = "",
}) => {
  const sizeClasses = {
    small: "p-4",
    medium: "p-8",
    large: "p-12",
  };

  const spinnerSizes = {
    small: "w-6 h-6 border-2",
    medium: "w-10 h-10 border-4",
    large: "w-16 h-16 border-6",
  };

  return (
    <div
      className={`flex flex-col items-center justify-center text-center ${sizeClasses[size]} ${className}`}
    >
      <div
        className={`${spinnerSizes[size]} border-gray-200 border-t-orange-500 rounded-full animate-spin mb-4`}
      ></div>
      <div className="text-gray-600 text-sm">{message}</div>
    </div>
  );
};

export default LoadingSpinner;
